export const RECEIVE_TIMELINE = 'RECEIVE_TIMELINE';
export const SAVED_TIMELINE = 'SAVED_TIMELINE';
export const ADD_WEEK = 'ADD_WEEK';
export const DELETE_WEEK = 'DELETE_WEEK';
export const SET_BLOCK_EDITABLE = 'SET_BLOCK_EDITABLE';
export const CANCEL_BLOCK_EDITABLE = 'CANCEL_BLOCK_EDITABLE';
export const UPDATE_BLOCK = 'UPDATE_BLOCK';
export const ADD_BLOCK = 'ADD_BLOCK';
export const DELETE_BLOCK = 'DELETE_BLOCK';
export const INSERT_BLOCK = 'INSERT_BLOCK';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const RESET_TITLES = 'RESET_TITLES';
export const RESTORE_TIMELINE = 'RESTORE_TIMELINE';
export const DELETE_ALL_WEEKS = 'DELETE_ALL_WEEKS';

export const BLOCK_KIND_RESOURCES = 5;
